import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import RestoreIcon from '@mui/icons-material/Restore';
import { Card, IconButton, Paper, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { DataGrid } from '@mui/x-data-grid';
import { default as React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { useStyles } from '../../theme/theme';
import LinkCategory from "../coupon/category/LinkCategory";
import UnLinkCategory from "./category/UnLinkCategory";



// global veriables
let propsData = {};

function Getallcoupon() {
  // state---->
  const [linkCategory, setLinkCategory] = useState(false);
  const [unlinkCategory, setUnLinkCategory] = useState(false);


  const navigate = useNavigate();
  const classes = useStyles();

  const [coupons, setCoupons] = useState([]);
  const [isdeleteId, setIsDeleteId] = useState();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  // const [isUsed, setIsUsed] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isMore, setIsMore] = useState(false);
  const [load, setLoad] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [pageSize, setPageSize] = useState(25);

  const linkCategorySelector = useSelector((state) => state.linkCategory);
  const { status } = linkCategorySelector;

  const unLinkCategorySelector = useSelector((state) => state.unlinkCategory);
  const { status: statusUnLink } = unLinkCategorySelector;


  const couponsColomns = [
    {
      field: 's_no',
      headerName: 'S. No.',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      filterable: false,
      renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
    },
    {
      field: '_id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'name',
      headerName: 'Name',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'image',
      headerName: 'Image',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            <img width={40} src={params?.row?.images?.mobile} />
          </>
        )
      },
    },
    {
      field: 'price',
      headerName: 'Price',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            <Stack>
              {params?.row?.price?.denominations?.map((price, idx) => {
                return <Typography key={idx}>{price}</Typography>
              })}
            </Stack>
          </>
        )
      },
    },
    {
      field: 'country',
      headerName: 'Country',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography>
          {params?.row?.country?.[0]?.name ??
            params?.row?.country?.name ??
            "—"}
        </Typography>
      ),
    },
    {
      field: 'profit', headerName: 'Add Profit',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => navigate(`/detailCoupon?SKU=${params?.row?.sku}&prices=${params?.row?.price?.denominations}`)}><LinkIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'wallet',
      headerName: 'Wallet',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'category',
      headerName: 'Linked Category',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
      renderCell: (params) => <Typography>{params?.row?.category?.name}</Typography>
    },
    {
      field: 'link_category', headerName: 'Link Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setLinkCategory(true);
              propsData = {
                sku: params?.row?.sku,
              };
            }}><LinkIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'unlink_category', headerName: 'Un-Link Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setUnLinkCategory(true);
              propsData = {
                catId: params?.row?.category?.category_id,
                sku: params?.row?.sku,
                is_deleted: true,
              };
            }}><LinkOffIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'is_deleted',
      headerName: 'Is Deleted',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'edit', headerName: 'Edit Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              navigate(`/editcouponlist?couponId=${params?.row?._id}`);
            }}><EditIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'delete',
      headerName: 'Delete Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setIsDeleteId(params?.row?._id);
              handleOpen();
            }}><DeleteIcon color='error' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
      hide: true,
    },
    {
      field: 'revert',
      headerName: 'Revert Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setIsDeleteId(params?.row._id);
              restoreHandler();
            }}
          ><RestoreIcon color='success' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      hide: true,
    },
    {
      field: 'expiry',
      headerName: 'Expiry',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'updated_at',
      headerName: 'Updated At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
  ]


  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const deleteHandler = async () => {
    //console.log("voucherId-->", isdeleteId);
    const res = await axios.delete("/admin/coupon/delete", {
      data: { couponId: isdeleteId, is_deleted: true },
    });
    const data = await res.data;
    if (data) {
      alert(res.data.message);
      handleClose();
      setCoupons([]);
      fetchCoupon();
    }
  };

  const restoreHandler = async () => {
    //console.log("voucherId-->", isdeleteId);
    const res = await axios.delete("/admin/coupon/delete", {
      data: { couponId: isdeleteId, is_deleted: false },
    });
    const data = await res.data;
    if (data) {
      alert(res.data.message);
      handleClose();
      setCoupons([]);
      fetchCoupon();
    }
  };

  const fetchCoupon = () => {
    setPage(0);
    // setLoad(true);
    setIsMore(false);
    //console.log("-->", isDeleted);
    axios.get(`admin/coupons/${isDeleted}`).then((res) => {
      //console.log("data-->", res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });

  };

  useEffect(() => {
    fetchCoupon();
  }, [status, statusUnLink, isDeleted, limit]);


  return (
    <>
      {/* <section className={CardStyle.main}> */}


      <section>
        <section>
          <div className={Dropdown.dropdown}>
            <Button variant='contained' color='info' sx={{ my: 2 }} className={Dropdown.dropbtn}>Is Deleted</Button>
            <div
              className={Dropdown.dropdown_content}
              style={{ zIndex: "10" }}
            >
              <a
                onClick={() => {
                  setIsDeleted(false);
                }}
              >
                false
              </a>
              <a
                onClick={() => {
                  setIsDeleted(true);
                }}
              >
                true
              </a>
            </div>
          </div>
        </section>
      </section>
      <Paper sx={{
        bgcolor: '#fff',
        '& .super-app-theme--header': {
          bgcolor: '#DC8449',
          color: '#fff',
        },
      }} elevation={0}>


        <DataGrid
          className={classes.root}
          sx={{
            border: 0,
          }}
          hideFooterPagination
          getRowHeight={() => 'auto'}
          autoHeight
          rows={coupons}
          columns={couponsColomns}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          disableRowSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          //  pagination
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[25, 50, 100]}
          disableColumnSelector
          columnVisibilityModel={{
            delete: !isDeleted,
            revert: isDeleted
          }}
        />
      </Paper>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you Sure you want to Delete?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              onClick={() => {
                deleteHandler();
              }}
            >
              Yes
            </Button>
            <Button onClick={handleClose}>No</Button>
          </Typography>
        </Box>
      </Modal>

      {/* </section> */}
      {/* modal */}
      {
        linkCategory && (
          <LinkCategory
            linkCategory={linkCategory}
            setLinkCategory={setLinkCategory}
            propsData={propsData}
          />
        )
      }
      {
        unlinkCategory && (
          <UnLinkCategory
            unlinkCategory={unlinkCategory}
            setUnLinkCategory={setUnLinkCategory}
            propsData={propsData}
          />
        )
      }
    </>
  );
}

export default Getallcoupon;
